<template>
  <div>
    <!-- 新增-编辑 -->
    <el-form ref="staffForm" :model="fromInfo" :rules="rules" label-position="right" label-width="7rem">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="员工姓名" prop="realName" required>
            <el-input v-model="fromInfo.realName" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="phone" required>
            <el-input v-model="fromInfo.phone" maxlength="11" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="级别管理" prop="isAdmin" required>
            <el-select v-model="fromInfo.isAdmin" placeholder="请选择级别管理" @change="isAdminChange">
              <el-option v-for="(item, index) in dict.isAdmin" :key="index" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="职业类型" required prop="postType">
            <el-select v-model="fromInfo.postType" :disabled="postTypeIf" placeholder="请选择职业类型">
              <el-option v-for="item in dict.postType" :key="item.postId" :label="item.postName" :value="String(item.postId)" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="备注" class="add-remarks" prop="remarks" required>
            <el-input v-model="fromInfo.remarks" type="textarea" />
            <span v-if="fromInfo.remarks">还可以输入{{ titleMaxLength - fromInfo.remarks.length }}个字</span>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="width: 100%;display: flex;margin-left: 40%;">
        <div class="pop-btn" @click="Submission('staffForm')">{{ type === 'edit' ? '保存' : '添加' }}</div>
        <div class="pop-btn" @click="btnClose()">取消</div>
      </div>

    </el-form>
  </div>
</template>
<script>
  import {
    getDict
  } from '@/api/common'
  import {
    getPhoneIf,
    findPostType
  } from '@/api/personal/enterprise'

  export default {
    props: {
      // add 新增 - edit 编辑  默认add
      type: {
        type: String,
        default: 'add'
      },
      // 回显数据
      popData: {
        type: Object,
        default: () => {
          return {}
        }
      },
      // 获取用户信息
      usertype: {
        type: [String, Object, Number],
        default: ''
      }
    },
    data() {
      var checking = (rule, value, callback) => {
        getPhoneIf({
          phone: value
        }).then(res => {
          if (value == this.phoneIf) {
            callback()
          } else if (res.message == '手机号已经存在') {
            callback(new Error('手机号已经存在'))
          } else {
            callback()
          }
        }).catch(error => {
          console.log(error)
        })
      }
      return {
        // 字典
        dict: {
          isAdmin: [],
          postType: []
        },
        // 正则
        rules: {
          // 员工姓名
          realName: [{
              required: true,
              message: '必填'
            },
            {
              validator: this.$validate('names')
            }
          ],
          // 手机
          phone: [{
              required: true,
              message: '必填'
            },
            {
              validator: this.$validate('phone')
            },
            {
              trigger: 'blur',
              validator: checking
            }
          ],
          postType: [{
            required: true,
            message: '必填'
          }],
          isAdmin: [{
            required: true,
            message: '必填'
          }],
          // 备注
          remarks: [{
            required: true,
            message: '必填'
          }]
        },
        // 表单信息
        fromInfo: {
          realName: '',
          phone: '',
          isAdmin: '',
          postType: '',
          remarks: ''
        },
        // 判断是否是编辑
        phoneIf: null,
        // 用户角色类型
        userType: this.usertype,
        // userAdmin
        userAdmin: false,
        // 职业类型 是否禁选
        postTypeIf: true,
        // 如果是编辑
        executeOnce: 0,
        // 备注字数
        titleMaxLength: 255,
        // 判断是否是第一次加载
        postTypeone: true
      }
    },
    watch: {
      'fromInfo.remarks'() {
        if (this.fromInfo.remarks.length > this.titleMaxLength) {
          this.fromInfo.remarks = String(this.fromInfo.remarks).slice(0, this.titleMaxLength)
        }
      }
    },
    created() {
      // 判断是否是编辑（手机号查重用）
      this.phoneIf = this.popData.phone
      // 深拷贝
      if (this.type === 'edit') this.fromInfo = JSON.parse(JSON.stringify(this.popData))


      const _this = this

      async function creat() {
        await _this.getDict('isAdmin')
        // await _this.getDict('postType')
        _this.isAdminChange()
        // _this.screenFilter()
      }

      creat() 
    },
    methods: {
      // 管理级别选中筛选
      isAdminChange(data) {
        console.log(data)
        this.userAdmin = true
        if (this.userType && this.userAdmin == true) {
          this.postTypeIf = false
          const con = {
            isAdmin: this.fromInfo.isAdmin
          }
          if (this.postTypeone) {
            this.postTypeone = false
          } else {
            this.fromInfo.postType = ''
          }
          findPostType(con).then(res => {
            console.log('1111111111',res)
            this.dict.postType = res.result
          })
        }
        this.screenFilter()
      },
      // 判断回显
      IfChoice(data) {
        this.dict.postType = data
        // 从新选中下拉
        if (this.type == 'edit') {
          if (this.executeOnce == 0) {
            this.executeOnce++
            this.fromInfo.postType = this.popData.postType
          } else {
            this.fromInfo.postType = data[0].value
          }
        } else {
          this.fromInfo.postType = this.popData.postType
        }
        // if (this.type == 'edit') {
        //   this.fromInfo.postType = data[0].value
        // } else {
        //   this.fromInfo.postType = this.popData.postType
        // }
      },
      // 下拉筛选
      screenFilter() {
        // if (this.userType == 2) {
        //   getDict('postType').then(res => {
        //     this.dict.postType = JSON.parse(res.result)
        //     console.table(this.dict.postType)
        //     if (this.fromInfo.isAdmin == 1) {
        //       const postFilter = this.dict.postType.filter(res => {
        //         return res.label == '经理'
        //       })
        //       // 从新赋值字典
        //       this.IfChoice(postFilter)
        //     } else if (this.fromInfo.isAdmin == 2) {
        //       const postFilter = this.dict.postType.filter(res => {
        //         return res.label == '行政管理' || res.label == '发布人员' || res.label == '网站管理员'
        //       })
        //       // 从新赋值字典
        //       this.IfChoice(postFilter)
        //     } else if (this.fromInfo.isAdmin == 3) {
        //       const postFilter = this.dict.postType.filter(res => {
        //         return res.label == '司机' || res.label == '押运人' || res.label == '普通职员'
        //       })
        //       // 从新赋值字典
        //       this.IfChoice(postFilter)
        //     }
        //   })
        // } else {
        //   getDict('goodPostType').then(res => {
        //     this.dict.postType = JSON.parse(res.result)
        //     console.table(this.dict.postType)
        //     if (this.fromInfo.isAdmin == 1) {
        //       const postFilter = this.dict.postType.filter(res => {
        //         return res.label == '经理'
        //       })
        //       // 从新赋值字典
        //       this.IfChoice(postFilter)
        //     } else if (this.fromInfo.isAdmin == 2) {
        //       const postFilter = this.dict.postType.filter(res => {
        //         return res.label == '行政管理' || res.label == '发布人员' || res.label == '网站管理员'
        //       })
        //       // 从新赋值字典
        //       this.IfChoice(postFilter)
        //     } else if (this.fromInfo.isAdmin == 3) {
        //       const postFilter = this.dict.postType.filter(res => {
        //         return res.label == '普通员工'
        //       })
        //       // 从新赋值字典
        //       this.IfChoice(postFilter)
        //     }
        //   })
        // }
      },
      // 获取字典
      getDict(type) {
        getDict(type).then(res => {
          console.log(res)
          this.dict[type] = JSON.parse(res.result)
        })
      },
      // 提交
      Submission(formName) {
        console.log(formName)
        this.$refs[formName].validate(valid => {
          if (valid) {
            console.log(this.fromInfo)
            this.$emit('click', {
              type: this.type,
              data: this.fromInfo
            })
            this.$message({
              type: 'success',
              message: this.type == 'edit' ? '保存成功!' : '添加成功！'
            })
          } else {
            return false
          }
        })
      },
      btnClose() {
        this.$emit('click', {
          type: "close",
          data: this.fromInfo
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "./staff.scss";
</style>
